var version = '6.4.2';

module.exports = version;
